
export default ($timeout) => ({
    restrict: 'A',
    scope: false,
    link(scope, element, attrs) {
        element.on('click', function () {
            angular.element(attrs.focusOther).focus();
        });
    }
});